import React, { useState, useEffect } from "react";
import { useOne, IResourceComponentsProps } from "@pankod/refine-core";
import { DescriptionItem } from "../../../components/text-layout/descriptionItem.text";

import {
    Show,
    Card,
    Row,
    Col,
    Space,
} from "@pankod/refine-antd";

import { Typography } from 'antd';

import { urlPath } from "../../../utility/url";
import { ToggleConnectedBankingOptionsModel } from "./components/modal/connected-banking-set-options.model";
import BackTitle from "components/back-title";
const { Text } = Typography;

export const ConnectedBankingShow: React.FC<IResourceComponentsProps> = () => {
    let url = urlPath()
    let [refreshConnectedBankingData, setRefreshConnectedBankingData] = useState(false);

    let {
        data: connectedBankingData,
        isLoading: connectedBankingLoading,
        refetch: refetchconnectedBankingData
    } = useOne<any>({
        dataProviderName: "grapghQl",
        resource: 'connectedBankingAccountsViaInternalPortalById',
        id: '',
        metaData: { 
            bankAccountId: url.lastElement,
            tableRefresh: refreshConnectedBankingData,
         },
        queryOptions: {
            enabled: true,
            onSuccess: () => {
                setRefreshConnectedBankingData(false);
            },
        },
    });

    useEffect(() => {
        if (refreshConnectedBankingData) {
            refetchconnectedBankingData();
        }
    }, [refreshConnectedBankingData]);


    const refetchConnectedBanking = (message: boolean) => {
        setRefreshConnectedBankingData(message);
    };

    let connectedBankingDetail = connectedBankingData?.data || {};
    let connectedBankingLabel = `${connectedBankingDetail?.authorization?.bankIntegration?.bankServiceProvider?.name} - ${connectedBankingDetail?.maskedAccountNo}`

    return (
        <Show
            isLoading={connectedBankingLoading}
            title={<BackTitle title={connectedBankingLabel} />}
            headerButtons={({ defaultButtons }) => (<></>)}
        >
            <Row className="company-wrapper connected-full-height" gutter={[24, 24]}>
                <Col lg={12} md={12}>
                    <h2>Integrator Details</h2>
                    <Card size="small" className="h-100">
                        <Row>
                            <Col lg={16}>
                                <DescriptionItem title="Name" content={connectedBankingDetail?.authorization?.bankIntegration?.description} />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8}>
                                <DescriptionItem title="Upi Support" content={connectedBankingDetail?.authorization?.bankIntegration?.isQuickPayUpiSupported ? 'Enabled': 'Disabled'} />
                            </Col>
                            <Col lg={8}>
                                <DescriptionItem title="Bank Transfer Support" content={connectedBankingDetail?.authorization?.bankIntegration?.isQuickPayBankTransferSupported ? 'Enabled': 'Disabled'} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col lg={12} md={12}>
                    <h2>Bank Account Details</h2>
                    <Card size="small" className="h-100">
                        <Row gutter={24}>
                            <Col lg={12}>
                                <DescriptionItem title="Account No" content={connectedBankingDetail.accountNo} />
                            </Col>
                            <Col lg={12}>
                                <DescriptionItem title="Balance" content={connectedBankingDetail.balance} />
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col lg={8}>
                                <DescriptionItem title="Quick Pay Enabled" content={connectedBankingDetail?.isQuickPayEnabled ? 'Enabled': 'Disabled'} />
                            </Col>
                        </Row>
                        <Text italic={true} underline={true}> Preferred of Bank Account </Text>
                        <Row gutter={24}>
                            <Col lg={11}>
                                <DescriptionItem title="Upi Support" content={connectedBankingDetail?.isPreferredForQuickPayUpi ? 'Enabled': 'Disabled'} />
                            </Col>
                            <Col lg={11}>
                                <DescriptionItem title="Bank Transfer Support" content={connectedBankingDetail?.isPreferredForQuickPayBankTransfer ? 'Enabled': 'Disabled'} />
                            </Col>
                        </Row>
                        <Space direction="vertical">
                            {connectedBankingData && <ToggleConnectedBankingOptionsModel refetchConnectedBanking={refetchConnectedBanking} connectedBankingDetail={connectedBankingDetail}/>}
                        </Space>
                    </Card>
                </Col>
            </Row>
        </Show>
    );
};
